var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1304_33441)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 104C110.719 104 134 80.7188 134 52C134 23.2812 110.719 0 82 0C53.2812 0 30 23.2812 30 52C30 80.7188 53.2812 104 82 104Z",
    fill: "#5DB77A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1304_33441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7264 79.11L80.9649 63.6106C82.6337 62.8324 83.3557 60.8487 82.5775 59.1799L62.9482 17.0847L49.6561 12.2468L22.4609 24.9281C20.7921 25.7063 20.0701 27.69 20.8483 29.3588L43.2957 77.4974C44.0738 79.1662 46.0575 79.8882 47.7264 79.11Z",
    fill: "#E1FFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6567 12.2468L62.9489 17.0848L53.8838 21.3119L49.6567 12.2468Z",
    fill: "#5DB77A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1304_33441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6162 67.7832H100.291C102.132 67.7832 103.625 66.2904 103.625 64.4491V18.0022L93.6228 8H63.6162C61.7749 8 60.2822 9.49271 60.2822 11.3341V64.4491C60.2822 66.2904 61.7749 67.7832 63.6162 67.7832Z",
    fill: "#E1FFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.623 8L103.625 18.0021H93.623V8Z",
    fill: "#5DB77A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1304_33441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4746 63.5911L115.713 79.0905C117.382 79.8686 119.366 79.1466 120.144 77.4778L139.773 35.3826L134.935 22.0905L107.74 9.40911C106.071 8.63093 104.087 9.35294 103.309 11.0218L80.862 59.1604C80.0838 60.8292 80.8058 62.8129 82.4746 63.5911Z",
    fill: "#E1FFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.936 22.0903L139.773 35.3825L130.708 31.1554L134.936 22.0903Z",
    fill: "#5DB77A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16C29.7614 16 32 13.7614 32 11C32 8.23858 29.7614 6 27 6C24.2386 6 22 8.23858 22 11C22 13.7614 24.2386 16 27 16Z",
    fill: "#E1FFEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 116C27.866 116 31 112.866 31 109C31 105.134 27.866 102 24 102C20.134 102 17 105.134 17 109C17 112.866 20.134 116 24 116Z",
    fill: "#E1FFEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151 42C154.866 42 158 38.866 158 35C158 31.134 154.866 28 151 28C147.134 28 144 31.134 144 35C144 38.866 147.134 42 151 42Z",
    fill: "#E1FFEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140 12C142.209 12 144 10.2091 144 8C144 5.79086 142.209 4 140 4C137.791 4 136 5.79086 136 8C136 10.2091 137.791 12 140 12Z",
    fill: "#E1FFEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86C58 72.7452 68.7452 62 82 62C95.2548 62 106 72.7452 106 86C106 99.2548 95.2548 110 82 110C68.7452 110 58 99.2548 58 86Z",
    fill: "#5DB77A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1304_33441",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 74,
    width: 24,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74H70V98H94V74Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1304_33441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 90L82 86M82 86L78 90M82 86V95M90.39 92.39C91.3653 91.8583 92.1358 91.0169 92.5798 89.9986C93.0239 88.9804 93.1162 87.8432 92.8422 86.7667C92.5682 85.6901 91.9434 84.7355 91.0666 84.0534C90.1898 83.3714 89.1108 83.0007 88 83H86.74C86.4373 81.8292 85.8731 80.7423 85.0899 79.821C84.3067 78.8997 83.3248 78.1678 82.2181 77.6806C81.1113 77.1934 79.9085 76.9634 78.7001 77.0079C77.4916 77.0524 76.309 77.3703 75.2411 77.9377C74.1732 78.505 73.2479 79.3071 72.5346 80.2836C71.8213 81.2601 71.3387 82.3855 71.1229 83.5754C70.9072 84.7653 70.9641 85.9885 71.2892 87.1533C71.6143 88.318 72.1992 89.3939 73 90.3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1304_33441",
    x: -3.46484,
    y: 8.24683,
    width: 110.355,
    height: 115.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1304_33441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1304_33441",
    result: "effect2_dropShadow_1304_33441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1304_33441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1304_33441",
    x: 36.2822,
    y: 4,
    width: 91.3433,
    height: 107.783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1304_33441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1304_33441",
    result: "effect2_dropShadow_1304_33441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1304_33441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1304_33441",
    x: 56.5488,
    y: 5.09595,
    width: 107.224,
    height: 118.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1304_33441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1304_33441",
    result: "effect2_dropShadow_1304_33441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1304_33441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1304_33441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ed1191db4d2fc907e710518f27274994.svg";
export { ForwardRef as ReactComponent };